/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import {
  BATCH_NUMBER_NOT_NULL,
  DELETE_BATCH_COMPLETED,
  ERROR_BATCH_DELETED,
  REBATE_PROGRAM_REQUIRED_REQ,
} from '../../../../../../SharedModules/Errors/constantMessageData';
import SVGComponent from '../../../../../../SharedModules/SVGComponents/SVGComponents';
import { RadioGroupComponent } from '../../../../../Display/Claim/component/SelectClaim/SelectClaimSearchComponent';
import { NDCDetailsTextFieldComponent } from '../../../../../Display/NDC/component/NDCDetails/NDCDetailsHeaderDetailsComponent';
import { PLAN_TYPE_DATA } from '../../DeleteCheckLog/utils/constant';
import { getBatchDetails, setDeleteBatchFilterValue } from '../store/action';
import DeleteBatchPopup from './DeleteBatchPopup';
import { Tooltip } from '@mui/material';

const DeleteBatchHeader = ({
  searchFilter,
  rebateData,
  setErrorMessages,
  setSuccessMessages,
  setDiscrepancies,
}) => {
  const dispatch = useDispatch();
  const [modal, setModal] = useState({ open: false, data: null });

  const handleClose = () => {
    setModal({ open: false, data: null });
  };

  return (
    <>
      <div className='row'>
        <div className='col-6'>
          <fieldset className='custom-fieldset'>
            <legend className='same-font-family'>Plan Type</legend>
            <div className='p-0 mt-2 row'>
              <div className='mui-custom-form col-12 m-0'>
                <RadioGroupComponent
                  data={PLAN_TYPE_DATA}
                  value={searchFilter && searchFilter.planType}
                  onChange={(_, value) => {
                    dispatch(setDeleteBatchFilterValue('planType', value));
                    dispatch(setDeleteBatchFilterValue('rpc', null));
                    dispatch(setDeleteBatchFilterValue('checkPayeeCd', null));
                  }}
                />
              </div>
            </div>
          </fieldset>
        </div>
        <div className='col-3'>
          <NDCDetailsTextFieldComponent
            label='Rebate Program'
            required
            value={searchFilter && searchFilter.rpc}
            className='ml-0 with-select'
            select
            selectReset
            selectData={rebateData}
            disabled={false}
            onChange={(e) => {
              if (e.target.value === "") {
                dispatch(setDeleteBatchFilterValue('rpc', null));
                dispatch(setDeleteBatchFilterValue('checkPayeeCd', null));
              } else {
                const filterArr = rebateData.filter(
                  (item) => item.value === e.target.value
                );

                if (filterArr.length > 0) {
                  dispatch(
                    setDeleteBatchFilterValue('rpc', filterArr[0].value)
                  );
                  dispatch(
                    setDeleteBatchFilterValue(
                      'checkPayeeCd',
                      filterArr[0].checkPayeeCd
                    )
                  );
                }
              }
            }}
          />
        </div>
        <div className='col-3'>
          <Tooltip
            title={`${searchFilter?.batchNum}`}
            open={searchFilter?.batchNum?.length > 25}
            arrow
          >
          <NDCDetailsTextFieldComponent
            label='Batch Number'
            required
            value={(searchFilter && searchFilter.batchNum) || ''}
            className='ml-0 mb-0'
            disabled={false}
            onChange={(e) => {
              dispatch(setDeleteBatchFilterValue('batchNum', e.target.value));
            }}
          />
          </Tooltip>
        </div>

        <div className='col-12 my-3 d-flex align-items-center justify-content-end'>
          <Button
            className='btn-success same-font-family d-flex align-items-center'
            onClick={() => {
              const localErrorMessage = [];
              setDiscrepancies([]);
              if (!searchFilter || !searchFilter.rpc) {
                localErrorMessage.push(REBATE_PROGRAM_REQUIRED_REQ);
              }

              if (!searchFilter || !searchFilter.batchNum) {
                localErrorMessage.push(BATCH_NUMBER_NOT_NULL);
              }

              if (localErrorMessage.length > 0) {
                setSuccessMessages([]);
                setErrorMessages(localErrorMessage);
              } else {
                setSuccessMessages([]);
                setErrorMessages([]);
                dispatch(
                  getBatchDetails(
                    {
                      checkPayeeCd: searchFilter.checkPayeeCd,
                      batchNum: searchFilter.batchNum,
                      deleteFlag: false,
                      rebateProgramCd: searchFilter.rpc,
                    },
                    (data) => {
                      if (data && data.batchNum) {
                        setModal({ open: true, data });
                      } else if (data && data.length > 0) {
                        setDiscrepancies(data);
                      }
                    },
                    (message) => {
                      setErrorMessages(message ? [message] : []);
                    }
                  )
                );
              }
            }}
          >
            <SVGComponent iconName='Create-new-icon' />{' '}
            <span style={{ paddingLeft: '5px' }}>Delete Batch</span>
          </Button>
        </div>
      </div>
      <DeleteBatchPopup
        handleClose={handleClose}
        data={modal.data}
        open={modal.open}
        onConfirmClick={() => {
          setSuccessMessages([]);
          setErrorMessages([]);
          dispatch(
            getBatchDetails(
              {
                batchNum: modal.data && modal.data.batchNum,
                //checkPayeeCd: modal.data && modal.data.checkPayeeCd,
                deleteFlag: true,
                //batchDt: modal.data && modal.data.batchDt,
                //totCheckCnt: modal.data && modal.data.totCheckCnt,
                //totCheckAmt: modal.data && modal.data.totCheckAmt,
                checkPayeeCd: modal.data && modal.data.checkPayeeCd,
                rebateProgramCd: searchFilter.rpc,
              },
              (data) => {
                if (data && data.deleteFlag) {
                  setSuccessMessages([DELETE_BATCH_COMPLETED]);
                  dispatch(setDeleteBatchFilterValue('batchNum', null));
                } else {
                  setErrorMessages([ERROR_BATCH_DELETED]);
                }
                handleClose();
              },
              (errMsg) => {
                setErrorMessages([errMsg]);
                handleClose();
              }
            )
          );
        }}
      />
    </>
  );
};

export default DeleteBatchHeader;
